if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (this.form) {
          this.form.querySelector('[name=id]').disabled = false;
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        }
        
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt, customQty = 0) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        // const formData = new FormData(this.form);
        // if (this.cart) {
        //   formData.append(
        //     'sections',
        //     this.cart.getSectionsToRender().map((section) => section.id)
        //   );
        //   formData.append('sections_url', window.location.pathname);
        //   this.cart.setActiveElement(document.activeElement);
        // }
        // if (customQty) {
        //   formData.set('quantity', customQty);
        // }
        // config.body = formData;

        const originalFormData = new FormData(this.form);
        let mainVariantQty = originalFormData.get('quantity');
        if (!mainVariantQty) {
          mainVariantQty = 1;
        }
        const formData = {};
        formData.sections_url = window.location.pathname;
        formData.sections = this.cart ? this.cart.getSectionsToRender().map((section) => section.id) : '';
        let mainVariantId = this.form.querySelector('[name="id"]').value;

        formData.items = [
          {
            id: mainVariantId,
            quantity: customQty ? customQty : mainVariantQty,
          }
        ]

        if (document.querySelector(`.addon-products-wrapper[data-parent-form-id="${this.form.getAttribute('id')}"] .addon-item.selected`)) {
          document.querySelectorAll(`.addon-products-wrapper[data-parent-form-id="${this.form.getAttribute('id')}"] .addon-item.selected`).forEach((item) => {
            formData.items.push({
              id: item.getAttribute('data-variant-id'),
              quantity: item.querySelector('.addon-product-qty input[type="number"]').value,
              properties: {
                // _parentBundleId: bundleId
              }
            });
          });
        }

        const fetchRequestOpts = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        };

        // fetch(`${routes.cart_add_url}`, config)
        fetch(window.Shopify.routes.root + 'cart/add.js', fetchRequestOpts)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: mainVariantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: mainVariantId, cartData: response });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
